import React from 'react';
import type RovoSearchPageType from '@jira/spa-apps__rovo-search/src/index.tsx';
import { getNavigationResources } from '@jira/router-resources__navigation/src/getNavigationResources.tsx';
import { globalLayout } from '@jira/platform__layouts-global-layout/src/index.tsx';
import { createEntry } from '@jira/platform__routing-route-entry/src/createEntry.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { newRovoSearchRoute } from '@jira/router-routes__rovo-search-routes/src/newRovoSearchRoute.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { Route } from '@atlassian/react-resource-router';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyRovoSearchPage = lazyForPaint<typeof RovoSearchPageType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-rovo-search", jiraSpaEntry: "async-rovo-search" */ '@jira/spa-apps__rovo-search/src/index.tsx'
			),
		),
	{
		ssr: false,
	},
);

const RovoSearchPage = () => (
	<LazyPage Page={LazyRovoSearchPage} pageId="rovo-search" shouldShowSpinner={false} />
);

export const newRovoSearchRouteEntry: Route = createEntry(newRovoSearchRoute, () => ({
	group: 'search',
	ufoName: 'search-page',
	// eslint-disable-next-line no-restricted-syntax
	component: RovoSearchPage,
	isRedirect: false,
	layout: globalLayout,
	resources: [...getNavigationResources()],
	forPaint: [LazyRovoSearchPage],
	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'shell-only',
	},
}));
